import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import React from 'react';

const Confirmation = ({
  title,
  message,
  onClose,
  onConfirm,
  loading = false
}: {
  title: string;
  message: string;
  onClose: any;
  onConfirm: any;
  loading?: boolean;
}) => {
  return (
    <Dialog
      open
      onClose={loading ? undefined : onClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'>
      <DialogTitle id='alert-dialog-title'>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id='alert-dialog-description'>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button onClick={onConfirm} autoFocus disabled={loading}>
          {loading ? <CircularProgress size={18} color='inherit' /> : 'Confirm'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

Confirmation.defaultProps = {
  loading: false
};

export default React.memo(Confirmation);
